export const authenticationWorker = async () => {
  const key = import.meta.env.VITE_WORKER_KEY;
  const date = new Date().toISOString().slice(0, 10).replace(/-/g, '/');
  const input = key + date;

  const encoder = new TextEncoder();
  const data = encoder.encode(input);

  const hashBuffer = await crypto.subtle.digest('SHA-256', data);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  return hashArray.map((byte) => byte.toString(16).padStart(2, '0')).join('');
};
